module.exports = __webpack_public_path__ + "static/media/wrapper-button-see-finished.4d25c9e6.png";